webpackJsonp([32],{

/***/ 1511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteUserForm_vue__ = __webpack_require__(1820);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07e4b50a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteUserForm_vue__ = __webpack_require__(1946);
function injectStyle (ssrContext) {
  __webpack_require__(1944)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07e4b50a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteUserForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07e4b50a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteUserForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1555);
function injectStyle (ssrContext) {
  __webpack_require__(1553)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1554);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1624:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo.a7b8e63.svg";

/***/ }),

/***/ 1671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    emits: ['onChange'],
    props: {
        label: {},
        checkModel: {},
        color: {},
        noMargin: {},
        tooltipText: {},
        noPadding: {},
        checkboxError: {}
    },
    data: function data() {
        return {
            vmodel: null
        };
    },

    watch: {
        checkModel: function checkModel(newValue, oldValue) {
            this.vmodel = newValue;
            if (document.getElementById(this.label) != null) {
                document.getElementById(this.label).checked = newValue;
            }
        }
    },
    methods: {
        changed: function changed() {
            this.$emit('onChange', this.vmodel);
        }
    },
    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.vmodel = _this.checkModel;

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ 1677:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/TransparencyLogo.9957347.svg";

/***/ }),

/***/ 1705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckBoxCrfi_vue__ = __webpack_require__(1671);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de29f1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckBoxCrfi_vue__ = __webpack_require__(1708);
function injectStyle (ssrContext) {
  __webpack_require__(1706)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckBoxCrfi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de29f1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckBoxCrfi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1706:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1707);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1000b0e3", content, true, {});

/***/ }),

/***/ 1707:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".long-cont{min-width:200px;padding:10px;border-radius:5px}.long-cont.no-margin{padding-top:5px;padding-bottom:5px;margin:0;min-width:unset}.long-cont.no-pad{padding-top:5px;padding-bottom:5px;margin:5px}.long-cont-grayed{color:#fff}.long-cb-cont{display:block;position:relative;padding-left:35px;cursor:pointer;font-size:14px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.long-cont>label{margin-bottom:0;line-height:25px}.long-cb-cont input{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.long-checkmark{color:#fff;position:absolute;top:0;left:0;height:25px;width:25px;border:1px solid #fff;border-radius:5px;-webkit-box-shadow:inset 0 4px 4px rgba(0,0,0,.25);box-shadow:inset 0 4px 4px rgba(0,0,0,.25)}.long-cb-cont input:checked~.long-checkmark{background-color:#fff}.long-cb-cont:hover input~.long-checkmark{border:1px solid #fff;background-color:hsla(0,0%,100%,.4)}.long-checkmark:after{content:\"\";position:absolute;display:none}.long-cb-cont input:checked~.long-checkmark:after{display:block}.long-cb-cont .long-checkmark:after{left:8px;top:2px;width:7px;height:15px;border:solid #000;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.color-box{border:1px solid #000;border-radius:5px;height:25px;width:25px}.tippy-tooltip.customTheme-theme{background-color:#346f8b;text-align:left;font-size:16px}.tippy-popper[x-placement^=left] .tippy-tooltip.customTheme-theme .tippy-arrow{border-left:8px solid #346f8b}.error{text-align:left!important;color:#fd8282;font-size:11px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/CheckBoxCrfi.vue"],"names":[],"mappings":"AACA,WAEI,gBAAiB,AACjB,aAAc,AACd,iBAAmB,CACtB,AACD,qBACI,gBAAiB,AACjB,mBAAoB,AACpB,SAAU,AACV,eAAiB,CACpB,AACD,kBACI,gBAAiB,AACjB,mBAAoB,AACpB,UAAY,CACf,AACD,kBAEI,UAAa,CAChB,AACD,cACI,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,eAAgB,AAChB,eAAgB,AAChB,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAkB,CACrB,AACD,iBACI,gBAAmB,AACnB,gBAAkB,CACrB,AACD,oBACI,kBAAmB,AACnB,UAAW,AACX,eAAgB,AAChB,SAAU,AACV,OAAS,CACZ,AACD,gBACI,WAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,sBAAwB,AACxB,kBAAmB,AACnB,mDAA0D,AAClD,0CAAkD,CAC7D,AACD,4CACI,qBAAyB,CAC5B,AACD,0CACI,sBAAwB,AACxB,mCAA2C,CAC9C,AACD,sBACI,WAAY,AACZ,kBAAmB,AACnB,YAAc,CACjB,AACD,kDACI,aAAe,CAClB,AACD,oCACI,SAAU,AACV,QAAS,AACT,UAAW,AACX,YAAa,AACb,kBAAoB,AACpB,yBAA0B,AAC1B,gCAAiC,AACjC,uBAAyB,CAC5B,AACD,WACI,sBAAwB,AACxB,kBAAmB,AACnB,YAAa,AACb,UAAY,CACf,AACD,iCACI,yBAA0B,AAC1B,gBAAiB,AACjB,cAAgB,CACnB,AACD,+EACI,6BAA+B,CAClC,AACD,OACQ,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CACnC","file":"CheckBoxCrfi.vue","sourcesContent":["\n.long-cont {\n    /* margin: 10px; */\n    min-width: 200px;\n    padding: 10px;\n    border-radius: 5px;\n}\n.long-cont.no-margin {\n    padding-top: 5px;\n    padding-bottom: 5px;\n    margin: 0;\n    min-width: unset;\n}\n.long-cont.no-pad{\n    padding-top: 5px;\n    padding-bottom: 5px;\n    margin: 5px;\n}\n.long-cont-grayed {\n    /* background-color: #1988A8; */\n    color: white;\n}\n.long-cb-cont {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    cursor: pointer;\n    font-size: 14px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n.long-cont > label {\n    margin-bottom: 0px;\n    line-height: 25px;\n}\n.long-cb-cont input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n.long-checkmark {\n    color: white;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 25px;\n    width: 25px;\n    border: 1px solid white;\n    border-radius: 5px;\n    -webkit-box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n            box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n}\n.long-cb-cont input:checked ~ .long-checkmark {\n    background-color: white ;\n}\n.long-cb-cont:hover input ~ .long-checkmark {\n    border: 1px solid white;\n    background-color: rgba(255, 255, 255, 0.4);\n}\n.long-checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n}\n.long-cb-cont input:checked ~ .long-checkmark:after {\n    display: block;\n}\n.long-cb-cont .long-checkmark:after {\n    left: 8px;\n    top: 2px;\n    width: 7px;\n    height: 15px;\n    border: solid black;\n    border-width: 0 3px 3px 0;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n}\n.color-box {\n    border: solid 1px black;\n    border-radius: 5px;\n    height: 25px;\n    width: 25px;\n}\n.tippy-tooltip.customTheme-theme {\n    background-color: #346F8B;\n    text-align: left;\n    font-size: 16px;\n}\n.tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {\n    border-left: 8px solid #346F8B;\n}\n.error {\n        text-align: left !important;\n        color: #FD8282;\n        font-size: 11px;\n        font-weight: bold;\n        font-family: 'Open Sans', sans-serif !important;\n        font-style: normal !important;\n        font-weight: 400 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"horizontal",staticStyle:{"align-items":"center"}},[_c('div',{class:{ 'long-cont': true, 'long-cont-grayed': _vm.vmodel, 'no-margin': _vm.noMargin, 'no-pad': _vm.noPadding}},[_c('label',{staticClass:"long-cb-cont mt-4 mb-1",attrs:{"for":_vm.label}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vmodel),expression:"vmodel"}],attrs:{"type":"checkbox","id":_vm.label,"value":"label"},domProps:{"checked":Array.isArray(_vm.vmodel)?_vm._i(_vm.vmodel,"label")>-1:(_vm.vmodel)},on:{"change":[function($event){var $$a=_vm.vmodel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="label",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.vmodel=$$a.concat([$$v]))}else{$$i>-1&&(_vm.vmodel=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.vmodel=$$c}},_vm.changed]}}),_vm._v(" "),_c('span',{staticClass:"long-checkmark",style:(_vm.checkboxError.length != 0 ? 'border: 2px solid #FD8282 !important;' : '')}),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0px","color":"white"}},[_vm._v(_vm._s(_vm.$t(_vm.label)))])]),_vm._v(" "),(_vm.checkboxError.length != 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(_vm.checkboxError))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1820:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Button_vue__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CheckBoxCrfi_vue__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(297);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_2__components_Button_vue__["a" /* default */],
        CheckBoxCrfi: __WEBPACK_IMPORTED_MODULE_3__components_CheckBoxCrfi_vue__["a" /* default */]
    },
    data: function data() {
        return {
            emailErrorMsg: '',
            passwordErrorMsg: '',
            passwordRepeatErrorMsg: '',
            email: '',
            password: '',
            passwordRepeat: '',
            serverErrors: [],
            checkboxError: '',
            confirmCheckbox: false
        };
    },

    methods: {
        passwordChange: function passwordChange(_) {
            this.passwordRepeatErrorMsg = '';
            this.passwordErrorMsg = '';

            if (this.password.length == 0) {
                this.passwordErrorMsg = 'Required';
            }

            if (this.password != this.passwordRepeat) {
                this.passwordRepeatErrorMsg = 'Passwords must match.';
            }
        },
        emailChange: function emailChange() {
            this.emailErrorMsg = '';
            if (this.email.length == 0) {
                this.emailErrorMsg = 'Required';
                return;
            }

            if (!this.email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                this.emailErrorMsg = 'Email not valid.';
            }
        },
        confirm: function confirm() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var user;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.confirmCheckbox) {
                                    _this.checkboxError = 'Confirmation required.';
                                }

                                if (_this.password.length == 0) {
                                    _this.passwordErrorMsg = 'Required';
                                }

                                if (_this.passwordRepeat.length == 0) {
                                    _this.passwordRepeatErrorMsg = 'Required';
                                }

                                if (_this.email.length == 0) {
                                    _this.emailErrorMsg = 'Required';
                                }

                                if (!(_this.passwordRepeatErrorMsg.length > 0 || _this.passwordErrorMsg.length > 0 || _this.checkboxError.length > 0 || _this.emailErrorMsg.length > 0 || _this.email.length == 0 || _this.password.length == 0 || _this.passwordRepeat.length == 0 || !_this.confirmCheckbox)) {
                                    _context.next = 8;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 8:
                                user = {
                                    Password: _this.password,
                                    Email: _this.email
                                };


                                Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_103" /* loginUser */])(user).then(function (response) {
                                    var token = response.data.token;
                                    __WEBPACK_IMPORTED_MODULE_5_axios__["default"].defaults.headers.common['Authorization'] = 'Bearer ' + token;

                                    Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["u" /* deleteOwnAccount */])().then(function (_) {
                                        _this.$refs['confirm-dialog'].showModal();
                                        setTimeout(_this.exit, 7000);
                                    }).catch(function (error) {
                                        _this.serverErrors = ['Login/password incorrect.'];

                                        if (error == 'Unauthorized access') {
                                            _this.serverErrors = ['Unauthorized Role'];
                                        } else {
                                            _this.serverErrors = ['Login/password incorrect.'];
                                        }
                                    });
                                }).catch(function (error) {
                                    _this.serverErrors = ['Login/password incorrect.'];

                                    if (error == 'Unauthorized access') {
                                        _this.serverErrors = ['Unauthorized Role'];
                                    } else {
                                        _this.serverErrors = ['Login/password incorrect.'];
                                    }
                                });

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        changeConfirmCheckbox: function changeConfirmCheckbox(value) {
            this.checkboxError = '';
            this.confirmCheckbox = value;

            if (!this.confirmCheckbox) {
                this.checkboxError = 'Confirmation required.';
            }
        },
        passwordRepeatChange: function passwordRepeatChange(_) {
            this.passwordRepeatErrorMsg = '';

            if (this.passwordRepeat != this.password) {
                this.passwordRepeatErrorMsg = 'Passwords must match.';
            }
        },
        exit: function exit() {
            this.$store.dispatch('logout');
            this.$router.push('/');
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            this.$store.dispatch('logout');

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1944:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1945);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("d54d271c", content, true, {});

/***/ }),

/***/ 1945:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1503);
exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".top-logo-bar[data-v-07e4b50a]{width:100%;height:100px;background:#347c93}.section-header[data-v-07e4b50a]{margin-bottom:20px;margin-top:40px;font-weight:600;font-size:24px}.main-header[data-v-07e4b50a]{font-weight:700;font-size:1.4rem;margin-top:20px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:center;align-content:center;width:100%}section[data-v-07e4b50a]{padding-right:40vw}p[data-v-07e4b50a]{text-align:justify}li[data-v-07e4b50a]{font-weight:700}.policy-container[data-v-07e4b50a]{height:calc(100% - 100px);overflow-y:scroll;padding-left:calc(15vw + 30px);padding-right:calc(15vw + 30px)}@media only screen and (max-width:700px){.policy-container[data-v-07e4b50a]{padding-left:5%;padding-right:5%}section[data-v-07e4b50a]{padding-right:5%}}.gradient[data-v-07e4b50a]{background-image:-webkit-gradient(linear,left top,left bottom,from(#31929f),to(#356a86));background-image:linear-gradient(#31929f,#356a86)}.label[data-v-07e4b50a]{font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:600!important;font-size:.8rem!important;color:#fff}p[data-v-07e4b50a]{color:#fff}.underlined[data-v-07e4b50a]{text-decoration:underline}.bold[data-v-07e4b50a]{font-weight:700}.bg[data-v-07e4b50a]{text-align:center;background-color:#fff;background-image:url(" + escape(__webpack_require__(1506)) + ");background-size:cover;background-repeat:no-repeat;background-position:0 0}.error[data-v-07e4b50a]{text-align:left!important;color:#fd8282;font-size:11px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}input[data-v-07e4b50a],input[data-v-07e4b50a]:focus{background:transparent;border:none;border-bottom:1px solid #fff;padding-left:0;font-size:1rem;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important;padding-left:10px;color:#add0d7}input[data-v-07e4b50a]:-webkit-autofill,input[data-v-07e4b50a]:-webkit-autofill:focus,input[data-v-07e4b50a]:-webkit-autofill:hover,select[data-v-07e4b50a]:-webkit-autofill,select[data-v-07e4b50a]:-webkit-autofill:focus,select[data-v-07e4b50a]:-webkit-autofill:hover,textarea[data-v-07e4b50a]:-webkit-autofill,textarea[data-v-07e4b50a]:-webkit-autofill:focus,textarea[data-v-07e4b50a]:-webkit-autofill:hover{border:0 solid green;-webkit-text-fill-color:#add0d7;-webkit-box-shadow:0 0 0 0 transparent inset;-webkit-transition:background-color 5000s ease-in-out 0s;transition:background-color 5000s ease-in-out 0s;border-bottom:1px solid #fff}input[data-v-07e4b50a]::-webkit-input-placeholder{color:#a6c2cd}input[data-v-07e4b50a]::-moz-placeholder{color:#a6c2cd}input[data-v-07e4b50a]::-ms-input-placeholder{color:#a6c2cd}input[data-v-07e4b50a]::placeholder{color:#a6c2cd}.footer[data-v-07e4b50a]{position:absolute;bottom:0}.lightColor[data-v-07e4b50a]{color:#8eabb9;background:#8eabb9}.themeColor[data-v-07e4b50a]{color:#337b91;background:#337b91}.rounded[data-v-07e4b50a]{border-radius:.75rem!important}.no-radius[data-v-07e4b50a]{border-radius:0}.exit-button[data-v-07e4b50a]{color:#fff;background:none;border:1px solid #fff;border-radius:15px;-webkit-transition-duration:.3s;transition-duration:.3s}.exit-button[data-v-07e4b50a]:hover{background:#fff;color:#373737;border:1px solid #373737}.confirm-button[data-v-07e4b50a]{color:#fff;background:#8fd1aa;border-radius:30px;border:none;font-size:15px}.login-button[data-v-07e4b50a]{color:#fff;background:transparent;border:none}.noselect[data-v-07e4b50a]{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}dialog[data-v-07e4b50a]::-webkit-backdrop{background-color:#000;opacity:.75}dialog[data-v-07e4b50a]::backdrop{background-color:#000;opacity:.75}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Users/DeleteUserForm.vue"],"names":[],"mappings":"AACA,+BACI,WAAY,AACZ,aAAc,AACd,kBAAoB,CACvB,AACD,iCACI,mBAAoB,AACpB,gBAAiB,AACjB,gBAAiB,AACjB,cAAgB,CACnB,AACD,8BACI,gBAAiB,AACjB,iBAAkB,AAClB,gBAAiB,AACjB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,0BAA2B,AACvB,qBAAsB,AAC1B,UAAY,CACf,AACD,yBACI,kBAAoB,CACvB,AACD,mBACI,kBAAoB,CAEvB,AACD,oBACI,eAAiB,CACpB,AACD,mCACI,0BAA2B,AAC3B,kBAAmB,AACnB,+BAAgC,AAChC,+BAAiC,CACpC,AACD,yCACA,mCACQ,gBAAiB,AACjB,gBAAkB,CACzB,AACD,yBACQ,gBAAkB,CACzB,CACA,AACD,2BACQ,yFAA8F,AAC9F,iDAAoD,CAC3D,AACD,wBACQ,2CAAgD,AAChD,4BAA8B,AAC9B,0BAA4B,AAC5B,0BAA6B,AAC7B,UAAa,CACpB,AACD,mBACQ,UAAa,CACpB,AACD,6BACQ,yBAA2B,CAClC,AACD,uBACM,eAAkB,CACvB,AACD,qBACM,kBAAmB,AACnB,sBAAwB,AACxB,+CAAgD,AAChD,sBAAuB,AACvB,4BAA6B,AAC7B,uBAA8B,CACnC,AACD,wBACQ,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CACnC,AAaD,oDAXQ,uBAAwB,AACxB,YAAa,AACb,6BAA+B,AAC/B,eAAgB,AAChB,eAAgB,AAChB,2CAAgD,AAChD,4BAA8B,AAC9B,0BAA4B,AAC5B,kBAAmB,AACnB,aAAe,CAatB,AACD,wZASQ,qBAAwB,AACxB,gCAAiC,AACjC,6CAAkD,AAClD,yDAA0D,AAC1D,iDAAkD,AAClD,4BAA+B,CACtC,AACD,kDACQ,aAA0B,CACjC,AACD,yCACQ,aAA0B,CACjC,AACD,8CACQ,aAA0B,CACjC,AACD,oCACQ,aAA0B,CACjC,AACD,yBACQ,kBAAmB,AACnB,QAAU,CACjB,AACD,6BACQ,cAA0B,AAC1B,kBAA+B,CACtC,AACD,6BACQ,cAAyB,AACzB,kBAA8B,CACrC,AACD,0BACQ,8BAAgC,CACvC,AACD,4BACQ,eAAiB,CACxB,AACD,8BACQ,WAAa,AACb,gBAAiB,AACjB,sBAAwB,AACxB,mBAAoB,AACpB,gCAAiC,AACzB,uBAAyB,CACxC,AACD,oCACQ,gBAAkB,AAClB,cAAuB,AACvB,wBAAkC,CACzC,AACD,iCACQ,WAAa,AACb,mBAA+B,AAC/B,mBAAoB,AACpB,YAAa,AACb,cAAgB,CACvB,AACD,+BACQ,WAAa,AACb,uBAAwB,AACxB,WAAa,CACpB,AACD,2BACQ,2BAA4B,AAC5B,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAkB,CACzB,AACD,0CACQ,sBAAwB,AACxB,WAAc,CACrB,AACD,kCACQ,sBAAwB,AACxB,WAAc,CACrB","file":"DeleteUserForm.vue","sourcesContent":["\n.top-logo-bar[data-v-07e4b50a] {\n    width: 100%;\n    height: 100px;\n    background: #347C93;\n}\n.section-header[data-v-07e4b50a] {\n    margin-bottom: 20px;\n    margin-top: 40px;\n    font-weight: 600;\n    font-size: 24px;\n}\n.main-header[data-v-07e4b50a] {\n    font-weight: 700;\n    font-size: 1.4rem;\n    margin-top: 20px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -ms-flex-line-pack: center;\n        align-content: center;\n    width: 100%;\n}\nsection[data-v-07e4b50a] {\n    padding-right: 40vw;\n}\np[data-v-07e4b50a] {\n    text-align: justify;\n    /* margin-left: 2vw; */\n}\nli[data-v-07e4b50a] {\n    font-weight: 700;\n}\n.policy-container[data-v-07e4b50a] {\n    height: calc(100% - 100px); \n    overflow-y: scroll; \n    padding-left: calc(15vw + 30px);\n    padding-right: calc(15vw + 30px);\n}\n@media only screen and (max-width: 700px) {\n.policy-container[data-v-07e4b50a] {\n        padding-left: 5%;\n        padding-right: 5%;\n}\nsection[data-v-07e4b50a] {\n        padding-right: 5%;\n}\n}\n.gradient[data-v-07e4b50a] {\n        background-image: -webkit-gradient(linear, left top, left bottom, from(#31929f), to(#356a86));\n        background-image: linear-gradient(#31929f, #356a86);\n}\n.label[data-v-07e4b50a] {\n        font-family: 'Open Sans', sans-serif !important;\n        font-style: normal !important;\n        font-weight: 600 !important;\n        font-size: 0.8rem !important;\n        color: white;\n}\np[data-v-07e4b50a] {\n        color: white;\n}\n.underlined[data-v-07e4b50a] {\n        text-decoration: underline;\n}\n.bold[data-v-07e4b50a] {\n      font-weight: bold;\n}\n.bg[data-v-07e4b50a] {\n      text-align: center;\n      background-color: white;\n      background-image: url('~@/assets/img/cows.jpg');\n      background-size: cover;\n      background-repeat: no-repeat;\n      background-position: left top;\n}\n.error[data-v-07e4b50a] {\n        text-align: left !important;\n        color: #FD8282;\n        font-size: 11px;\n        font-weight: bold;\n        font-family: 'Open Sans', sans-serif !important;\n        font-style: normal !important;\n        font-weight: 400 !important;\n}\ninput[data-v-07e4b50a] {\n        background: transparent;\n        border: none;\n        border-bottom: 1px solid white;\n        padding-left: 0;\n        font-size: 1rem;\n        font-family: 'Open Sans', sans-serif !important;\n        font-style: normal !important;\n        font-weight: 400 !important;\n        padding-left: 10px;\n        color: #ADD0D7;\n}\ninput[data-v-07e4b50a]:focus {\n        background: transparent;\n        border: none;\n        border-bottom: 1px solid white;\n        padding-left: 0;\n        font-size: 1rem;\n        font-family: 'Open Sans', sans-serif !important;\n        font-style: normal !important;\n        font-weight: 400 !important;\n        padding-left: 10px;\n        color: #ADD0D7;\n}\ninput[data-v-07e4b50a]:-webkit-autofill,\n    input[data-v-07e4b50a]:-webkit-autofill:hover,\n    input[data-v-07e4b50a]:-webkit-autofill:focus,\n    textarea[data-v-07e4b50a]:-webkit-autofill,\n    textarea[data-v-07e4b50a]:-webkit-autofill:hover,\n    textarea[data-v-07e4b50a]:-webkit-autofill:focus,\n    select[data-v-07e4b50a]:-webkit-autofill,\n    select[data-v-07e4b50a]:-webkit-autofill:hover,\n    select[data-v-07e4b50a]:-webkit-autofill:focus {\n        border: 0px solid green;\n        -webkit-text-fill-color: #ADD0D7;\n        -webkit-box-shadow: 0 0 0px 0px transparent inset;\n        -webkit-transition: background-color 5000s ease-in-out 0s;\n        transition: background-color 5000s ease-in-out 0s;\n        border-bottom: 1px solid white;\n}\ninput[data-v-07e4b50a]::-webkit-input-placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n        color: rgb(166, 194, 205);\n}\ninput[data-v-07e4b50a]::-moz-placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n        color: rgb(166, 194, 205);\n}\ninput[data-v-07e4b50a]::-ms-input-placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n        color: rgb(166, 194, 205);\n}\ninput[data-v-07e4b50a]::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n        color: rgb(166, 194, 205);\n}\n.footer[data-v-07e4b50a] {\n        position: absolute;\n        bottom: 0;\n}\n.lightColor[data-v-07e4b50a] {\n        color: rgb(142, 171, 185);\n        background: rgb(142, 171, 185);\n}\n.themeColor[data-v-07e4b50a] {\n        color: rgb(51, 123, 145);\n        background: rgb(51, 123, 145);\n}\n.rounded[data-v-07e4b50a] {\n        border-radius:.75rem !important;\n}\n.no-radius[data-v-07e4b50a] {\n        border-radius: 0;\n}\n.exit-button[data-v-07e4b50a] {\n        color: white;\n        background: none;\n        border: white 1px solid;\n        border-radius: 15px;\n        -webkit-transition-duration: .3s;\n                transition-duration: .3s;\n}\n.exit-button[data-v-07e4b50a]:hover {\n        background: white;\n        color: rgb(55, 55, 55);\n        border: rgb(55, 55, 55) 1px solid;\n}\n.confirm-button[data-v-07e4b50a] {\n        color: white;\n        background: rgb(143, 209, 170);\n        border-radius: 30px;\n        border: none;\n        font-size: 15px;\n}\n.login-button[data-v-07e4b50a] {\n        color: white;\n        background: transparent;\n        border: none;\n}\n.noselect[data-v-07e4b50a] {\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n}\ndialog[data-v-07e4b50a]::-webkit-backdrop {\n        background-color: black;\n        opacity: 0.75;\n}\ndialog[data-v-07e4b50a]::backdrop {\n        background-color: black;\n        opacity: 0.75;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dialog',{ref:"confirm-dialog",staticClass:"gradient rounded",staticStyle:{"border":"2px solid white","color":"white"}},[_c('h3',[_vm._v("Account deleted successfully")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',[_vm._v("You will be redirected shortly to main page.")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"end"}},[_c('Button',{staticStyle:{"padding":"3px 10px","margin":"15px 10px 5px 0px"},attrs:{"buttonClass":"exit-button"},on:{"click":_vm.exit}},[_vm._v("Back to Main Page")])],1)]),_vm._v(" "),_c('div',[_c('div',{staticClass:"top-logo-bar",staticStyle:{"display":"flex","align-items":"center"}},[_c('router-link',{staticStyle:{"align-items":"left","display":"flex"},attrs:{"to":{name: 'login'}}},[_c('img',{staticClass:"app-logo",staticStyle:{"margin-left":"10vw","height":"35px","margin-top":"0px","padding-right":"20px","border-right":"1px solid #AEAEAE7F"},attrs:{"src":__webpack_require__(1624)}}),_vm._v(" "),_c('img',{staticClass:"app-logo",staticStyle:{"margin-left":"20px","height":"35px","margin-top":"0px"},attrs:{"src":__webpack_require__(1677)}})])],1)]),_vm._v(" "),_c('div',{staticClass:"policy-container"},[_c('h2',{staticClass:"main-header"},[_vm._v("Delete Account")]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-4 gradient rounded p-5 m-4",staticStyle:{"max-width":"100%","margin":"24px 0 !important"}},[_c('div',{staticStyle:{"padding-bottom":"30px"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control no-radius p-0",attrs:{"type":"email","name":"email","id":"email","placeholder":"Enter your e-mail","maxlength":"50"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},_vm.emailChange],"blur":_vm.emailChange}}),_vm._v(" "),(this.emailErrorMsg.length != 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(this.emailErrorMsg))]):_vm._e()]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control no-radius p-0",attrs:{"type":"password","name":"password","id":"password","placeholder":"Enter your password","maxlength":"100","aria-describedby":"password-help-block"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm.apply(null, arguments)},"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value},_vm.passwordChange],"blur":_vm.passwordChange}}),_vm._v(" "),(this.passwordErrorMsg.length != 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(this.passwordErrorMsg))]):_vm._e()]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordRepeat),expression:"passwordRepeat"}],staticClass:"form-control no-radius p-0",attrs:{"type":"password","name":"password-rep","id":"password-rep","placeholder":"Repeat your password","maxlength":"100","aria-describedby":"password-help-block"},domProps:{"value":(_vm.passwordRepeat)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm.apply(null, arguments)},"input":[function($event){if($event.target.composing){ return; }_vm.passwordRepeat=$event.target.value},_vm.passwordRepeatChange],"blur":_vm.passwordRepeatChange}}),_vm._v(" "),(this.passwordRepeatErrorMsg.length != 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(this.passwordRepeatErrorMsg))]):_vm._e()]),_vm._v(" "),_c('CheckBoxCrfi',{staticStyle:{"margin":"10px 0"},attrs:{"checkboxError":_vm.checkboxError,"noMargin":true,"label":'I want to delete my CRFI Monitoring account and understand that I will lose access to portal.'},on:{"onChange":_vm.changeConfirmCheckbox}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column my-1 pt-3"},[_c('div',{staticClass:"d-flex flex-row mb-1"},[_c('Button',{staticClass:"px-3 py-3 mt-3",attrs:{"buttonClass":"semi-bold confirm-button flex-grow-1","title":'Submit'},on:{"onClick":_vm.confirm}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row mb-1",staticStyle:{"justify-content":"center"}},_vm._l((_vm.serverErrors),function(item){return _c('span',{key:item,staticClass:"error"},[_vm._v(_vm._s(item))])}),0)])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"label text-left"},[_vm._v("\n                        By filling this form you can delete your CRFI Monitoring account. Data that will be deleted contains your:"),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Name and Surname")]),_vm._v(" "),_c('li',[_vm._v("Email Address")]),_vm._v(" "),_c('li',[_vm._v("Phone Number")]),_vm._v(" "),_c('li',[_vm._v("Connection to System")]),_vm._v(" "),_c('li',[_vm._v("Country of origin")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"label text-left mt-4 mb-1"},[_vm._v("E-MAIL")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"label text-left mt-4 mb-1"},[_vm._v("PASSWORD")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"label text-left mt-4 mb-1"},[_vm._v("REPEAT PASSWORD")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/32.235b00672286edc65c3c.js